var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMarkQuestion = function SvgMarkQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.4973 3.51583 8.48417 1.50269 6 1.5ZM6 8.625C5.68934 8.625 5.4375 8.37316 5.4375 8.0625C5.4375 7.75184 5.68934 7.5 6 7.5C6.31066 7.5 6.5625 7.75184 6.5625 8.0625C6.5625 8.37316 6.31066 8.625 6 8.625ZM6.375 6.68887C6.37493 6.5397 6.46328 6.40467 6.6 6.345C7.28663 6.04533 7.64687 5.28537 7.4439 4.56422C7.24094 3.84307 6.537 3.38224 5.79487 3.48469C5.05274 3.58714 4.49999 4.22145 4.5 4.97062C4.5 5.17773 4.66789 5.34562 4.875 5.34562C5.08211 5.34562 5.25 5.17773 5.25 4.97062C5.24981 4.59599 5.52609 4.27867 5.89719 4.22732C6.26828 4.17596 6.62036 4.40632 6.72192 4.76693C6.82347 5.12753 6.64336 5.50777 6.3 5.65762C5.88996 5.83658 5.62493 6.24149 5.625 6.68887C5.625 6.89598 5.79289 7.06387 6 7.06387C6.20711 7.06387 6.375 6.89598 6.375 6.68887Z",
    fill: "#8D909E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarkQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MarkQuestion.c4f36272.svg";
export { ForwardRef as ReactComponent };